module.exports = __webpack_public_path__ + "static/media/PICT0043.d0eca4a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_karneval/thumb/PICT0043.jpg
// module id = 504
// module chunks = 0